/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import * as t from "io-ts";

// required attributes
const OidcExchangeOtpResponseR = t.interface({});

// optional attributes
const OidcExchangeOtpResponseO = t.partial({
  maskedEmail: t.string,

  otpSessionUid: t.string,

  requiresOtpFlow: t.boolean
});

export const OidcExchangeOtpResponse = t.intersection(
  [OidcExchangeOtpResponseR, OidcExchangeOtpResponseO],
  "OidcExchangeOtpResponse"
);

export type OidcExchangeOtpResponse = t.TypeOf<typeof OidcExchangeOtpResponse>;
